var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrCodeBox"},[_c('div',{staticClass:"qrcode"},[(_vm.show)?_c('YCL',{attrs:{"labelInfo":_vm.labelInfo,"modelInfo":_vm.modelInfo}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }